"use client";

import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FrequentlyAskedQuestions() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: accordionRef,
    isVisible: accordionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    id: 1,
    question: "What areas does Car Service Connecticut serve?",
    answer: "We provide premium transportation services to and from Connecticut, with coverage extending to New York City, Long Island, and New Jersey. Our service area is designed to meet all your travel needs across the tri-state region."
  }, {
    id: 2,
    question: "Which airports do you service?",
    answer: "We service all major airports in the region including JFK (John F. Kennedy International), LGA (LaGuardia), EWR (Newark Liberty International), BDL (Bradley International), HPN (Westchester County), and TEB (Teterboro). We ensure timely pickups and drop-offs for all your airport transfer needs."
  }, {
    id: 3,
    question: "What types of vehicles are available?",
    answer: "Our premium fleet includes luxury sedans for individual or couple travel, spacious SUVs for families or small groups, and high-end luxury SUVs for those seeking the ultimate comfort and style. All vehicles are meticulously maintained and equipped with modern amenities."
  }, {
    id: 4,
    question: "What services do you offer?",
    answer: "We specialize in airport transfers, city-to-city rides, corporate travel solutions, and event or night-out transportation. Whether you need reliable business transportation or a luxurious ride for a special occasion, we have you covered."
  }, {
    id: 5,
    question: "How do I book a ride with Car Service Connecticut?",
    answer: "You can easily book a ride through our website, by phone, or via email. We recommend booking in advance, especially for airport transfers and corporate events, to ensure availability and the best service experience."
  }, {
    id: 6,
    question: "Are your drivers professional and licensed?",
    answer: "Absolutely. All our drivers are fully licensed, professionally trained, and undergo rigorous background checks. They are experienced in providing courteous, safe, and reliable transportation services, ensuring you reach your destination comfortably and on time."
  }];
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div ref={headerRef} className={`text-center mb-12 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-base sm:text-lg text-muted max-w-2xl mx-auto">
            Find answers to common questions about our premium transportation
            services.
          </p>
        </div>

        <div ref={accordionRef} className={`card transition-all duration-700 delay-200 ${accordionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="p-6 sm:p-8">
            {faqs.map((faq, i) => <div key={faq.id} data-index={i} className="border-b border-muted/20 last:border-b-0">
                <button onClick={() => toggleAccordion(i)} className="w-full py-5 flex items-start justify-between gap-4 text-left focus-ring transition-colors hover:text-accent group" aria-expanded={openIndex === i} aria-controls={`faq-answer-${faq.id}`}>
                  <span className="font-semibold text-base sm:text-lg text-foreground-secondary group-hover:text-accent transition-colors">
                    {faq.question}
                  </span>
                  <ChevronDown className={`size-5 text-muted shrink-0 mt-1 transition-transform duration-300 ${openIndex === i ? "rotate-180" : ""}`} />
                </button>
                <div id={`faq-answer-${faq.id}`} className={`overflow-hidden transition-all duration-300 ease-smooth ${openIndex === i ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`}>
                  <div className="pb-5 text-sm sm:text-base text-foreground-secondary/80 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}